import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "redwing-preview-limit-modal-shown";

const MigrationWarningModal = ({ level, remaining, isPremium, warningKey }) => {
  const storageKey = `${STORAGE_KEY}:${warningKey}`;
  const [open, setOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const previousRemaining = useRef(null);

  useEffect(() => {
    previousRemaining.current = null;
    setHasShown(window.localStorage.getItem(storageKey) === "true");
  }, [storageKey]);

  useEffect(() => {
    const currentRemaining = Number(remaining);
    if (!Number.isFinite(currentRemaining)) {
      return;
    }

    const previous = previousRemaining.current;
    previousRemaining.current = currentRemaining;

    if (
      isPremium ||
      hasShown ||
      previous === null ||
      previous <= 0 ||
      currentRemaining !== 0
    ) {
      return;
    }

    setHasShown(true);
    setOpen(true);
    window.localStorage.setItem(storageKey, "true");
  }, [hasShown, isPremium, remaining, storageKey]);

  if (!level || isPremium) {
    return null;
  }

  const exhausted = Number(remaining) === 0 || Number(level) >= 50;
  const close = () => {
    setOpen(false);
  };

  return (
    <Modal isOpen={open} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {exhausted ? "Tracking is paused" : "Your free preview"}
        </ModalHeader>
        <ModalBody>
          <Text>
            {exhausted
              ? "Your progress is safe. Upgrade to Premium to continue tracking."
              : `${remaining} issues left in your free preview. Premium lets you track the full reading order.`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={close} variant="ghost">
            Continue browsing
          </Button>
          <Button as={Link} to="/go-premium" colorScheme="red" onClick={close}>
            Go Premium
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MigrationWarningModal;
